// ABOUTME: React Query client configuration with defaults
// ABOUTME: Singleton QueryClient instance for entire app

import { QueryClient } from '@tanstack/react-query'

// CRITICAL: Create QueryClient OUTSIDE component (singleton)
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data considered stale after 5 minutes
      staleTime: 5 * 60 * 1000,

      // Keep unused data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,

      // Retry failed requests 1 time — but never a 404 (a deleted/unknown
      // resource won't appear on retry; it only delays the not-found state)
      retry: (failureCount: number, error: any) =>
        error?.response?.status !== 404 && failureCount < 1,

      // Refetch on window focus (good for exec dashboard)
      refetchOnWindowFocus: true,

      // Don't refetch on mount if data is fresh
      refetchOnMount: false,
    },
    mutations: {
      // Retry mutations 0 times (mutations should not auto-retry)
      retry: 0,
    },
  },
})
